import { FullStory, init } from '@fullstory/browser';
import Cookie from 'js-cookie';
import ComponentEvents from '@utils/component-events';

const isIncludedIn5Percent = () => {
  return Math.floor(Math.random() * (20 - 1 + 1)) + 1 === 1;
};

const recordFS = (user) => {
  init({ orgId: 'R4JR9' });

  if (user && user.id) {
    FullStory('setIdentity', {
      uid: user.id,
      properties: {
        displayName: user.name,
        email: user.email,
      },
    });
  }
};

const setup = (user) => {
  try {
    if (location.href.includes('global_search') || location.href.includes('import') || location.href.includes('/get_recs/')) {
      recordFS(user);
      return;
    }
  } catch { }

  if (Cookie.get('fs-rec') === 'false') {
    return;
  }

  if (Cookie.get('fs-rec') === 'true') {
    recordFS(user);
    return;
  }

  let internalSetup = function (resp) {
    if (resp) {
      let record = false;

      if (user && user.id) {
        record = true;
      } else if (isIncludedIn5Percent()) {
        record = true;
      }

      Cookie.set('fs-rec', record, { expires: 365 });

      if (record) {
        recordFS(user);
      }
    }
  };

  if (window.visitorCountry) {
    internalSetup(window.visitorCountry);
  } else {
    let unsub = ComponentEvents.on('updated-visitor-country', function (resp) {
      if (resp) {
        internalSetup(resp);
        unsub();
      }
    });
  }
};

export default {
  recordFS,
  setup,
};
